import { Component, OnInit, ViewChild, DebugElement } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { JobCategoryService } from '@app/services/jobCategory.service';
import { TechnologyService } from '@app/services/technology.service';
import { PriorityService } from '@app/services/priority.service';
import { JobDescriptionService } from '@app/services/jobDescription.service';
import { StatusService } from '@app/services/status.service';
import { JobService } from '@app/services/job.service'
import { JobSerializer } from '@app/model/serializer/job-serializer';
import { Job } from '@app/model/job';
import { JobCommentService } from '@app/services/jobComment.service'
import { JobComment } from '@app/model/jobComment';
import { User } from '@app/model/user';
import { JobDescription } from '@app/model/jobDescription';
import { FileUpload } from '@app/model/fileUpload';
import { JobDescriptionDocument } from '@app/model/jobDescriptionDocument';
import { JobDescriptionDocumentService } from '@app/services/jobDescriptionDocument.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DropDownComponent } from '@app/components/dropDown/dropDown.component';
import { NgForm } from '@angular/forms';
import { Messages } from '@app/constants/constant';
import{HandleDataService} from 'src/app/services/handleData.service';
import{CommonService}from 'src/app/services/common.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { QueryOptions } from '@app/model/query-options';
import { ApiService } from '@app/services/api.service';
import { ScheduleInterviewService } from '@app/services/scheduleInterview.service';
import { RecruiterService } from '@app/services/recruiterService';
import { ApplicantService } from '@app/services/applicant.service';
import { InterviewStepMapping } from '@app/model/interviewStepMapping';
import { InterviewStepService } from '@app/services/interviewStep.service';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { JobNextService } from '@app/services/job-next.service ';
@Component({
  selector: 'app-scheduleInterview',
  templateUrl: './scheduleInterview.component.html',
  styleUrls: ['./scheduleInterview.component.css'], 
  providers:[AutoCompleteModule]
})
export class ScheduleInterviewComponent implements OnInit {

  @ViewChild('scheduleInterviewForm',{static: false}) public scheduleInterviewForm: NgForm;
  primaryRecruiters:any = []

  scheduleInterview :any={ 
    jobCategory:'',
    technology:'',
    priority:'',
    jobStatus:'',
    jobDescription:'',
    noOfPosition:'',
    createdOn:'',
    openJobCount:'',
    pendingJobCount:'',
    closedJobCount:'',

  }
  candiDateDetail:any={
    email:'',
    name:'',
    phone:'',
    cvFile:'',
    ctc:'',
    bonus:'',
    currentTitle:'',
    resumeUrl:'',
    applicantId:'',
    name_phone:'',
    resumeFileName:'',
    alternatePhone :'',
    remark:'',
    sourceType:'',
    sourceName:'',
  }
  interviewDetail:any={
    type:'',
    interviewer:[],
    date:'',
    time:'',
    comments:'',
    interviewMode:'',
    showPreviousFeedback:false,
    primaryRecruiter:''
  }
  applicantObj:string;
  jobId:any;
  app:any;
  searchedApplicant :any;
  pageSize: number = 500;
  first: number = 0;
  interviewSteps:any;
  interviewModes:any;
  roles:any;
  display :boolean;
  applicants:any;
  defaultApplicant:any;
  fileUrl:any;
  params:any;
  endUrl:any;
  subscription:any;
  res:any;
  interviewId:any;
  interviewStepId:any
  candidateFieldsDisable:boolean=false;
  minDate:any= new Date();
  interviewDate: string;
  TimeError: boolean;
  DateError: boolean;
  defaulatDate:any;
  showcandidateAlreadyInProcessError:any;
  showEditIcon: boolean=false;
  cancelDisplay:boolean=false;
  sourceNameOptions: any;
  sourceTypeOptions: any;
  selectedInterviewer:any[] = [];
  loginUser:any;
  
  duplicateInvertviews = [];
  duplicateInterviewColumns = [
    { field: 'startTime', header: 'Date & Time', type: 'date'},
    { field: 'candidateName', header: 'Candidate Name'},
    { field: 'jobDescriptionName', header: 'Jd Name'},
    { field: 'interviewerName', header: 'Primary Recruiter'},
    { field:'interviewStepStatusName', header:'Status'  }
  ];
  
  constructor(
    private _apiJobCategories: JobCategoryService,
    private _apiPriority: PriorityService,
    private _apiJobDescription: JobDescriptionService,
    private _apiTechnology: TechnologyService,
    private _apiStatus: StatusService,
    private _jobService: JobNextService,
    private _jobCommentService: JobCommentService,
    private _jobDescDocService: JobDescriptionDocumentService,
    private _router : Router,
    private _interviewStepService:InterviewStepService,
    private _toastService : MessageService,
    private _commonService: CommonService,
    private activatedRoute : ActivatedRoute,
    private _recruiterService: RecruiterService,
    private _applicantService: ApplicantService,
    private _HandleDataService: HandleDataService,
    private _scheduleInterviewService: ScheduleInterviewService,
    private _DatePipe:DatePipe,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    ) { }

    ngOnInit(): void {
      this.loginUser = JSON.parse(localStorage.getItem('currentUser')) ? JSON.parse(localStorage.getItem('currentUser'))['user'] : '';
      var time =new Date();

    this._commonService.list(this.queryParams(false,"name"),'source-type').subscribe(res => {
      this.sourceTypeOptions= res;
      });
      this.defaulatDate=new Date(time.setMinutes(0));
      this.jobId= this.activatedRoute.snapshot.params['id'];
      this.endUrl= this.activatedRoute.snapshot.params['name'];
      var date = new Date();
      date.setDate(date.getDate() + 1);
      this.interviewDetail.date=date;
      if(this.endUrl=='re-schedule' || this.endUrl=='next-round'){  
          this.res=this._HandleDataService.getReScheduleInterviewDetails()
          localStorage.setItem("clearFilter","true");
          if(this.res && this.res['applicant']){
          // this.candiDateDetail.email=this.res['email'];
          // this.candiDateDetail.phone=this.res['phone'];
          // this.candiDateDetail.ctc=this.res['applicant']['currentCtc'];
          // this.candiDateDetail.bonus=this.res['applicant']['bonus'];
          // this.candiDateDetail.currentTitle=this.res['applicant']['currentTitle'];
          // this.candiDateDetail.resumeUrl=this.res['applicant']['resumeUrl'];
          // this.candiDateDetail.applicantId=this.res['applicant']['id'];
          // this.candiDateDetail.resumeFileName=this.res['applicant']['resumeFileName'];
          // this.candiDateDetail.alternatePhone=this.res['applicant']['alternatePhone'];
          // this.candiDateDetail.remark=this.res['applicant']['remarks'];
          
          this.updateForm(this.res['applicant']);

          this.interviewId=this.res['id'];
          if(this.endUrl=='re-schedule'){
            localStorage.setItem("clearFilter","false");
            this.interviewDetail.interviewer=[];
            this.interviewStepId=this.res['interviewStepDetails'] ? this.res['interviewStepDetails']['id'] : null;
            this.interviewDetail.type={value:this.res['interviewStep']['id'],label:this.res['interviewStep']['name']};
            this.interviewDetail.interviewMode={value:this.res['interviewMode']['id'],label:this.res['interviewMode']['name']};
           // this.interviewDetail.interviewer= {value: this.res['interviewStepDetails']['interviewerObj']['id'] ,label:this.res['interviewer'] }
            this.interviewDetail.date=this.res['startDate'] ? new Date (new Date(this.res['startDate']).getTime()) : new Date();
            this.interviewDetail.time=this.res['startDate'] ? new Date (new Date(this.res['startDate']).getTime()) : new Date();
            this.interviewDetail.comments=this.res['interviewStepDetails']['comment'] ? this.res['interviewStepDetails']['comment'] : '';
            this.interviewDetail.showPreviousFeedback=this.res['interviewStepDetails']['showPreviousFeedback'] ? this.res['interviewStepDetails']['showPreviousFeedback'] : false;
           this.interviewDetail.primaryRecruiter=this.res['interviewStepDetails']['primaryRecruiter'] ? this.res['interviewStepDetails']['primaryRecruiter'] : '';
          }     
           
  
          this.applicantObj=this.res;
          this.showEditIcon =true;
          this.app=this.res['applicant'];

          }
          this._recruiterService.list(sortParamsRecruiter,Messages.endpoint.Recruiter).subscribe(res => {
            this.roles= res;
            this.interviewDetail.interviewer.shift();
            let data =[];
            if(this.res && this.res['interviewerObj']){
              for(let val of this.res['interviewerObj'] ){
                if (val.status > 0)
                    data.push(val.id);
              }
            }
            this.interviewDetail.interviewer = data;
          });
      }
      // this._jobService.read(this.jobId).subscribe(
      //   res => {
      //     console.warn(res);
      //       this.scheduleInterview.jobCategory= res.jobCategory ? res.jobCategory.name : '';
      //       this.scheduleInterview.technology= res.technology ? res.technology.name : '';
      //       this.scheduleInterview.priority= res.jobPriority ? res.jobPriority.name : '';
      //       this.scheduleInterview.jobStatus= res.jobStatus ? res.jobStatus.name : '';
      //       this.scheduleInterview.jobDescription= res.jobDescription ? res.jobDescription.name : '';
      //       this.scheduleInterview.noOfPosition=res.noOfVacancies ? res.noOfVacancies:'';
      //       this.scheduleInterview.openJobCount=res.openJobCount ? res.openJobCount: 0;
      //       this.scheduleInterview.closedJobCount=res.closedJobCount? res.closedJobCount : 0;
      //       this.scheduleInterview.pendingJobCount = res.pendingJobCount ?res.pendingJobCount : 0;
      //       this.scheduleInterview.createdOn=res.createdOn ? res.createdOn : '';
      //       //this.scheduleInterview.primaryRecruiters= res.jobAssignedRecruiter.users;
      //       this.primaryRecruiters=res.jobAssignedRecruiter.users;
      //       this.primaryRecruiters = this.primaryRecruiters.map(user=> {
      //         user.fullName= user.firstName + " " + user.lastName
      //         return user;
      //       })
      //       console.warn(this.primaryRecruiters);

      //   });
      let data;
      if(this.endUrl=="next-round"){
       data= {
        interviewId: this.interviewId,        
        jobId: this.jobId
      }
    }
    else{
      data= {
        jobId: this.jobId
      }
    }
      this._jobService.post(data).subscribe(res =>{
        console.warn(res);
               this.scheduleInterview.jobCategory= res.jobCategory ? res.jobCategory.name : '';
              this.scheduleInterview.technology= res.technology ? res.technology.name : '';
              this.scheduleInterview.priority= res.jobPriority ? res.jobPriority.name : '';
               this.scheduleInterview.jobStatus= res.jobStatus ? res.jobStatus.name : '';
              this.scheduleInterview.jobDescription= res.jobDescription ? res.jobDescription.name : '';
              this.scheduleInterview.noOfPosition=res.noOfVacancies ? res.noOfVacancies:'';
               this.scheduleInterview.openJobCount=res.openJobCount ? res.openJobCount: 0;
               this.scheduleInterview.closedJobCount=res.closedJobCount? res.closedJobCount : 0;
               this.scheduleInterview.pendingJobCount = res.pendingJobCount ?res.pendingJobCount : 0;
               this.scheduleInterview.createdOn=res.createdOn ? res.createdOn : '';
             //this.scheduleInterview.primaryRecruiters= res.jobAssignedRecruiter.users;
               this.primaryRecruiters=res.jobAssignedRecruiter.users;
               this.primaryRecruiters = this.primaryRecruiters.map(user=> {
                user.fullName= user.firstName + " " + user.lastName
                 return user;
               })
               if(this.endUrl== "next-round"){
               this.interviewDetail.primaryRecruiter =res.primaryRecruiter;
               }
      })
     
        var sortParams= this.queryParams(false,"name");
      // for passing request params. this is the job id
      this._commonService.list(sortParams,'interview-step').subscribe(res => {
          this.interviewSteps= res;
      });

      this._commonService.list(sortParams, 'interview-mode').subscribe(res => {
        this.interviewModes = res;
      });

      var p={}
      var sortParamsRecruiter= this.queryParams(false,"firstName");;
      this._recruiterService.list(sortParamsRecruiter,Messages.endpoint.Recruiter).subscribe(res => {
        this.roles= res;
      });
     
  }

  updateSource(sourceType){
    var endpointSource="source/sourceType/"+sourceType['id'];
    this._commonService.list(this.queryParams(false,"sourceName"),endpointSource,undefined,Messages.endpoint.sourceNameParams).subscribe(res => {
      this.sourceNameOptions= res;
    });
  }

  filterApplicant($event){
    var params= this.queryParams(false,"firstName");
    if($event.query){
      this._applicantService.list( params,Messages.endpoint.applicant_Search + $event.query.toLowerCase(),this.jobId).subscribe(res => {
        this.applicants= res;
      });
    }else{
      this._applicantService.list(params,Messages.endpoint.applicantJob,this.jobId).subscribe(res => {
        this.applicants= res;
      });
    } 
  }
  showDialog(bool){
    this.cancelDisplay=bool;
    this.applicantObj='';
  }
  updateForm(event){
    if(event['alreadyInProcess']){
     this.showcandidateAlreadyInProcessError=true;
     this.cancelDisplay=true;
    }else{
      this.candiDateDetail.email=event['email'];
      this.candiDateDetail.phone=event['phone'];
      this.candiDateDetail.ctc=event['currentCtc'];
      this.candiDateDetail.bonus=event['bonus'];
      this.candiDateDetail.currentTitle=event['currentTitle'];
      this.candiDateDetail.resumeUrl=event['resumeUrl'];
      this.candiDateDetail.resumeFileName=event['resumeFileName'];
      this.candiDateDetail.applicantId=event['id'];
      this.candiDateDetail.alternatePhone=event['alternatePhone'];
      this.candiDateDetail.remark=event['remarks'];
      this.candidateFieldsDisable=true;
      this.fileUrl=Messages.endpoint.fileUrlDomain + this.candiDateDetail.resumeUrl;
      this.showEditIcon =this.candiDateDetail.email?true:false;
      if(event['source']){
      this.candiDateDetail.sourceType={label:event['source']['sourceType']['name'],id:event['source']['sourceType']['id']};
      this.updateSource(event['source']['sourceType']);
      this.candiDateDetail.sourceName={sourceName:event['source']['sourceName'],id:event['source']['id']};
      }
      else if(event['referredBy']){
      this.candiDateDetail.sourceType={sourceName:event['sourceType']['name'],id:event['sourceType']['id']};
      this.updateSource(event['sourceType']);
      this.candiDateDetail.sourceName={label:event['referredBy']['lastName']?event['referredBy']['firstName']+" "+ event['referredBy']['lastName']: event['referredBy']['firstName'],id:event['referredBy']['id']};

      }
      else{
        this.candiDateDetail.sourceType=undefined;
        this.candiDateDetail.sourceName=undefined;
      }
    }
    
   
  }
  queryParams(noPageSize,sortField){

      const queryParams = new Object();
        // sort order as number, 1 for asc and -1 for dec
      queryParams['sortParam'] = { sortField: sortField, sortOrder: 1 };
      if(!noPageSize){
        queryParams['pageParam'] = {
          page:
              this.first / this.pageSize > 1
              ? this.first / this.pageSize + 1
              : this.first / this.pageSize,
            size: this.pageSize
          };
      }
      const dropDownSortingQueryOptions = new QueryOptions(queryParams);
      dropDownSortingQueryOptions.toQueryMap();
      return dropDownSortingQueryOptions;
  }
  showApplicantCreation = function (bool: boolean) { 
      this.display = bool;
      this.app=(this.endUrl=='re-schedule' || this.endUrl=='next-round')?this.applicantObj['applicant']:this.applicantObj;
  }
  setApplicantData= function (obj:Object) {
    this.applicantObj=obj;
    this.updateForm(this.applicantObj);
    
  }
  submitInterviewDetails(){
    var interviewDate= this._DatePipe.transform(this.interviewDetail.date,'yyyy/MM/dd');
    var todayDate = this._DatePipe.transform(new Date(),'yyyy/MM/dd');
   if(interviewDate < todayDate){
     this.DateError=true;
   }
   else if(interviewDate==todayDate) {
    if(this.interviewDetail.time.getHours()<new Date().getHours()){
     this.TimeError=true;
    }else if(this.interviewDetail.time.getHours()==new Date().getHours() && this.interviewDetail.time.getMinutes()< new Date().getMinutes()){
      this.TimeError=true;
    }else{
     this.TimeError=false;
     this.callScheduleInterviewService();
    }
  }
   else {
     this.TimeError=false;
     this.DateError=false;
     this.callScheduleInterviewService();
   } 
  }

  callScheduleInterviewService(){
    console.log(this.endUrl);
   this.spinner.show();
    this.params = this.submitInterviewParams();
    console.warn(this.params[0]);
    if(this.endUrl=='re-schedule'){
      this._interviewStepService.editJob(this.params[0],Messages.endpoint.Interview_updateInterviewStep).subscribe(res => {
        console.warn(res);
        if (res["mailSentOrNot"] == 1) {
          this._toastService.add({ severity: 'success', summary:Messages.interviewReScheduled, detail: '' });
        } else {
          this._toastService.add({ severity: 'warn', summary:"Interview scheduled successfully, however failed to send email.", detail: '' });

        }
        this._router.navigateByUrl('/view-scheduled-interview-list/' + this.jobId);
    });
    }else{
      this.http.post(environment.apiUrl+Messages.endpoint.interview,this.params).subscribe(res=>{
         this.spinner.hide();
        if (res["mailSentOrNot"] == 1) {
          this._toastService.add({ severity: 'success', summary:this.endUrl == 'next-round' ? Messages.nextRoundScheduled : Messages.interviewScheduled, detail: '' });
        } else {
          this._toastService.add({ severity: 'warn', summary:this.endUrl == 'next-round' ? Messages.nextRoundScheduled + ", however failed to send email.": Messages.interviewScheduled + ", however failed to send email.", detail: '' });
        }
        this._router.navigateByUrl('/view-scheduled-interview-list/' + this.jobId);
    });
    //   this._scheduleInterviewService.create( this.params).subscribe(res => {
    //     this._toastService.add({ severity: 'success', summary:this.endUrl == 'next-round' ? Messages.nextRoundScheduled : Messages.interviewScheduled, detail: '' });
    //     this._router.navigateByUrl('/view-scheduled-interview-list/' + this.jobId);
    // });
    }
  }

  submitInterviewParams(){
    var interviewSteps =[{
      "id":this.interviewStepId ? this.interviewStepId : null,
      "interviewStep": this.interviewDetail.type.value,
      "user": this.interviewDetail.interviewer.map(user=>{return user.value? user.value:user}).join(","),
      "pass": true,
      "startTime": this._DatePipe.transform(this.interviewDetail.date,'dd-MM-yyyy') + ' ' + this._DatePipe.transform(this.interviewDetail.time,'hh:mm a') ,
      "interviewStepStatus": this.endUrl=='re-schedule'?'2':'1',
      "comment": this.interviewDetail.comments,
      "interviewMode": this.interviewDetail.interviewMode.value,
      "scheduledById": this.loginUser.id,
      "showPreviousFeedback":this.interviewDetail.showPreviousFeedback,
      "primaryRecruiter":this.interviewDetail.primaryRecruiter.id

    }];

    var scheduleInterviewParams={
      "interviewId":this.interviewId ? this.interviewId:null,      
      "statusId":'1',
      "applicantId": this.candiDateDetail.applicantId,
      "jobId": this.jobId,
      "interviewStepMapping":interviewSteps,
      "scheduledById": this.loginUser.id,
      "primaryRecruiter": this.interviewDetail.primaryRecruiter.id
      }
    if(this.endUrl=='re-schedule'){
      return interviewSteps;
    }else{
      return scheduleInterviewParams;
    }
      
  }
  redirectToPreviousPage(){
    this.scheduleInterviewForm.reset();
    if(this.endUrl=='re-schedule' || this.endUrl=='next-round'){
      this._router.navigateByUrl('/view-scheduled-interview-list/' + this.jobId);
    }else{
      this._router.navigateByUrl('/interview-schedule-list');
      //this._router.navigateByUrl('/job');
    }
  }
  abc(){
    console.log(425, this.scheduleInterviewForm.value);
    this.scheduleInterviewForm.controls.primaryRecruiter.setValue("abc");
  }

  isInterviewScheduled() {
    this.duplicateInvertviews = [];
    if (this.checkInterviewDuplicateCondition()) {
      this.spinner.show();
      let data = {
        startTime : this._DatePipe.transform(
            this.interviewDetail.date,'dd-MM-yyyy') + ' ' + 
            this._DatePipe.transform(this.interviewDetail.time,'hh:mm a'),
        interviewerIds : this.interviewDetail.interviewer.map(user=> user.value? user.value:user).join(","),
      };

      this._scheduleInterviewService.post(data, 'interview/duplicate-interviewer-data')
        .subscribe(res => {
          this.spinner.hide();
          this.duplicateInvertviews = res;
          console.log(res);
        })
    }
  }

  checkInterviewDuplicateCondition() {
    if (
        this.interviewDetail.time &&
        this.interviewDetail.interviewer.length > 0 && 
        this.interviewDetail.date) {
          return true;
      }
      return false;

  }

  onHideDialog() {
    this.duplicateInvertviews = [];
    this.interviewDetail.time = '';
  }
}